import baseRequest from "../_core/baseRequest";

export default {
    createAndShow: params => baseRequest.post(`/contract/create-and-show`, params),
    getContractsBySubCompanyId: params =>
        baseRequest.get(`/contract/subcompanies/${params.subCompanyId}`, {
            params: { contractName: params.contractName }
        }),
    changeApprovalStatus: params => baseRequest.post(`/contract/${params.contractId}/approval`, params),
    createContract: params => baseRequest.post(`/contract/subcompanies/${params.subCompanyId}`, params.formData),
    getContractTemplates: () => baseRequest.get(`/contract/template`),
    changeContractTemplateActivation: params => baseRequest.post(`/contract/template/${params.templateId}/activation`, params),
    createTemplate: (params) => baseRequest.post(`/contract/template`, params),
    uploadDocumentToTemplateContract: params => baseRequest.put(`/contract/subcompanies/${params.subCompanyId}/document`, params.formData),
};